import React, { Component } from 'react';
import Modal from 'react-modal';
import cn from 'classnames';

import { formatPhoneNumber } from 'utils';
import { ROOT_URL } from 'constants/Config';
import iconUser from 'assets/images/icons/icon-user-sq.svg';
import Dialog from 'components/Modal';
import s from '../styles.scss';
import EmployerIntercation from '../EmployerInteraction';
import { withTranslation } from 'react-i18next';

class EmployeeList extends Component {
  state = {
    showPopup: false
  }

  UNSAFE_componentWillMount() {
    this.props.loadCompanyProfiles({});
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (nextState.showPopup) {
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    } else {
      document.getElementsByTagName('html')[0].style.overflow = 'initial';
    }
  }

  handleEditProfile = (agentId) => {
    this.setState({
      showPopup: true,
      ...(agentId ? { agentId } : { agentId: null })
    });
  }

  handleClose = () => {
    this.setState({
      showPopup: false,
      agentId: null
    });
  }

  handleDeleteClick = (id) => {
    this.props.deleteProfile({ userId: id });
  }

  render() {
    const { profiles, tariff, workersCount, t, isEnoughMembers } = this.props;
    const employers = profiles.data ? profiles.data.sort((e1, e2) => e2.id - e1.id) : [];
    const isProfileLoaded = !!employers.length;

    return (
      <div className={s.MembersContent}>
        <div className={s.AddEmployee}>
          <button
            className={cn(s.Button, s.ButtonNewMember, 'button-primary', 'button-primary--lg')}
            onClick={() => this.handleEditProfile(null)}
            disabled={!isProfileLoaded || isEnoughMembers || (tariff && tariff.countDay === 0)}
          >
            {t('components.profile.employeeList.new')}
          </button>
          {!isProfileLoaded &&
            <div className={s.AddEmployeeText}>
              {isEnoughMembers || (tariff && tariff.countDay === 0)
                ? t('components.profile.employeeList.deny')
                : t('components.profile.employeeList.allow', { countPeople: (((tariff && tariff.countPeople) || 0) - workersCount) })
              }
            </div>
          }
        </div>
        <div className={s.MembersList}>
          {employers.map(
            ({ firstName, lastName, position, phone, avatarId, hash, roleName, id }) =>
              // if (!hash) console.log(firstName, lastName, id);
               (
                 <div className={s.Member} key={id}>
                   <div className={s.MemberAvatar}>
                     <img
                       src={
                        avatarId ?
                        `${ROOT_URL}/image/get?id=${avatarId}&preset=profile_avatar` :
                        iconUser
                      }
                       alt=""
                     />
                   </div>
                   <div className={s.MemberInfo}>
                     <p className={s.MemberName}>{firstName} {lastName} {(roleName == 'owner') ? <span className={s.AdminTag}>
                       {t('components.profile.employeeList.admin')}
                     </span> : null}</p>
                     <p className={s.MemberPosition}>{position}</p>
                     <a href={`tel:+${phone}`} className={s.MemberPhone}>{formatPhoneNumber(phone)}</a>
                   </div>
                   <div className={s.MemberHover}>
                     {roleName !== 'admin' && roleName !== 'owner' &&
                     <button
                       className={cn(s.MemberAction, s.Edit)}
                       onClick={() => this.handleEditProfile(id)}
                     >
                       {t('components.profile.employeeList.edit')}
                     </button>
                    }
                     {roleName !== 'admin' && roleName !== 'owner' &&
                     <button
                       className={cn(s.MemberAction, s.Delete)}
                        // onClick={() => this.setState({ deletingEmployee: hash })}
                       onClick={() => this.setState({ deletingEmployee: id })}
                     >
                       {t('components.profile.employeeList.delete')}
                     </button>
                    }
                     <Dialog
                       title={t('components.profile.employeeList.deleteWorker')}
                      // isOpen={hash === this.state.deletingEmployee}
                       isOpen={id == this.state.deletingEmployee}
                       handleClose={() => this.setState({ deletingEmployee: null })}
                       contentStyle={{
                         minWidth: '736px',
                         minHeight: '120px'
                       }}
                     >
                       <div className={s.Dialog}>
                         {t('components.profile.employeeList.areYouSure', {
                           firstName,
                           lastName
                         })}
                         <div className={s.Buttons}>
                           <div
                             className={cn(s.Button, 'button-primary', 'button-primary--lg')}
                            // onClick={this.handleDeleteClick.bind(this, hash)}
                             onClick={() => this.handleDeleteClick(id)}
                           >
                             {t('components.profile.employeeList.delete')}
                           </div>
                           <div
                             className={s.ButtonCancel}
                             onClick={() => this.setState({ deletingEmployee: null })}
                           >
                             {t('components.profile.employeeList.cancel')}
                           </div>
                         </div>
                       </div>
                     </Dialog>
                   </div>
                 </div>
              )
          )}
        </div>
        {<Modal
          isOpen={this.state.showPopup}
          onRequestClose={this.handleClose}
          contentLabel="Modal"
          className={s.ModalContent}
          style={{
            overlay: {
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)'
            }
          }}
        >
          <EmployerIntercation
            {...profiles}
            agentId={this.state.agentId}
            onClose={this.handleClose}
          />
        </Modal>}
      </div>
    );
  }
}

export default withTranslation()(EmployeeList);



// WEBPACK FOOTER //
// ./src/components/Profile/EmployersList/EmployersList.js